import axios from 'axios'
import appConfig from '@/appconfig'
import store from '../store'
import endpoint from '@constants/apipath'
import constant from '@constants/constant'

export const actions = {
  init({ state, dispatch }) {},

  async uploadReport({ state }, { fileDetails } = {}) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.documentApiPath.sdUpload}`,
        fileDetails,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },

  sendNotication({ state }, { sdGetRequest } = {}) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.documentApiPath.sdEmailNotification}`,
        sdGetRequest,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
  },

  fetchCustomer({ state }, { pageNumber, pageSize } = {}) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.adminApiPath.getcustomers}?PageNumber=${pageNumber}&PageSize=${pageSize}&isActive=1&key=CustomerType&value=customer`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return error.response.status
        }
        return null
      })
  },

  downloadReports({ state }, { sdGetRequest } = {}) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.documentApiPath.sdDownload}`,
        sdGetRequest,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        let reportName = `${constant.scoreDisclosure}.csv`

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          var IECSV = response.data
          var fullTemplate = [IECSV]
          var blob1 = new Blob(fullTemplate, { type: 'text/html' })
          window.navigator.msSaveOrOpenBlob(blob1, reportName)
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', reportName)
          document.body.appendChild(link)
          link.click()
        }
        return response
      })
      .catch((error) => {
        return error
      })
  },
  getScoreDisclosure({ state }, { sdGetRequest } = {}) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.documentApiPath.sdReport}`,
        sdGetRequest,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  fetchCustomersByUserIdFamm({ commit }) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.adminApiPath.getcustomersbyuserid}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return null
      })
  },
}

function setHeaders() {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
  }
}
